import {Component, Inject} from '@angular/core';
import { CommonModule } from '@angular/common';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';
import {IFDEResponse} from '../interface';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-fde-extractor-stats',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss'],
})
export class StatsComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<any>,
    @Inject(MAT_SNACK_BAR_DATA) public data: IFDEResponse,
  ) {
  }
}
